<template>

	<div class="login-panel">
		<h2 class="login-panel__headline">
			<i class="icon icon-icon-maps-and-flags"></i>
			<span class="login-panel__headline__text">{{ viewTitle }}</span>
		</h2>

		<button
			v-if="'options' !== currentView"
			@click="resetView"
			class="btn btn--red"
			type="button"
		>Go back</button>

		<div
			v-if="'options' === currentView"
			class="login-panel__view login-panel__view--options"
		>
			<p class="login-panel__info push-ends">Please login or create an account to continue.</p>

			<div class="row">
				<div 
					v-if="show_pickup"
					class="col-md-6"
				>
					<button
						@click.prevent="handleOptionClick( 'login', 'Login' )"
						class="btn btn--outline btn--outline--red push-bottom btn-block"
					>Log in</button>

					<button
						@click.prevent="handleOptionClick( 'createAccount', 'Create New Account' )"
						class="btn btn--outline btn--outline--red push-bottom btn-block"
					>Create new account</button>

					<button
						@click.prevent="handleClickGuest"
						class="btn btn--outline btn--outline--red push-bottom btn-block"
					>Continue as guest</button>
				</div>
				<div 
					v-if="show_delivery"				
					class="col-md-6"
				>
					<button
						@click.prevent="handleOptionClick( 'login', 'Login as Penn Med User', true )"
						class="btn btn--outline btn--outline--orange  push-bottom btn-block"
					>Log in as Penn Med User</button>

					<button
						@click.prevent="handleOptionClick( 'createAccount', 'Create New Penn Med Account', true )"
						class="btn btn--outline btn--outline--orange  push-bottom btn-block"
					>Create new Penn Med account</button>
				</div>
			</div>
		</div>


		<form
			v-if="'login' === currentView"
			@submit.prevent="processLogin"
			class="login-panel__view login-panel__view--login"
		>
			<!-- <div 
				v-if="login.submit.error"
				v-html="login.submit.error"
				class="error text-red"
			></div> -->

			<LoginInputField
				:input="login.username"
				ref="loginUsername"
				field_label="Username"
				field_type="text"
			/>

			<LoginInputField
				:input="login.password"
				ref="loginPassword"
				field_label="Password"
				field_type="password"
			/>

			<div
				v-if="login.submit.error.length"
				v-html="login.submit.error"
				class="login-panel__view__error"
			></div>

			<button
				:disabled="loginSubmitIsDisabled"
				:class="{ 'is-submitting': login.submit.isSubmitting }"
				class="btn btn--red login-panel__view__submit"
				type="submit"
			>{{ actionBtnText }}</button>

			<a
				:href="forgot_pw_url"
				class="btn btn--outline btn--outline--red"
			>Forgot password?</a>
		</form>


		<form
			v-if="'createAccount' === currentView"
			@submit.prevent="processCreateAccount"
			class="login-panel__view login-panel__view--create-account"
		>
			<!-- <div 
				v-if="createAccount.submit.error"
				v-html="createAccount.submit.error"
				class="error text-red"
			></div> -->

			<LoginInputField
				:input="createAccount.firstName"
				ref="createAccountFirstName"
				field_label="First Name"
				field_type="text"
			/>

			<LoginInputField
				:input="createAccount.lastName"
				ref="createAccountLastName"
				field_label="Last Name"
				field_type="text"
			/>			

			<LoginInputField
				:input="createAccount.email"
				ref="createAccountEmail"
				field_label="Email"
				field_type="email"
			/>

			<LoginInputField
				:input="createAccount.password"
				ref="createAccountPassword"
				field_label="Password"
				field_type="password"
			/>

			<LoginInputField
				v-if="forPennMed"
				:input="createAccount.pennMedCode"
				ref="createAccountPennMed"
				field_label="Penn Med code"
				field_type="password"
			/>			

			<div
				v-if="createAccount.submit.error.length"
				v-html="createAccount.submit.error"
				class="login-panel__view__error"
			></div>

			<button
				:disabled="createAccountSubmitIsDisabled"
				:class="{ 'is-submitting': createAccount.submit.isSubmitting }"
				class="btn btn--red login-panel__view__submit"
				type="submit"
			>{{ actionBtnText }}</button>
		</form>
	</div> 
</template>


<script>
	import LoginInputField from '../components/LoginInputField.vue'
	import WpApi from '../helpers/WpApi.mjs'


	export default {
		name: 'LoginPanel',
		components: {
			LoginInputField
		},

		props: {
			forgot_pw_url: {
				type: 		String,
				required: 	true
			},
			show_pickup: {
				type: 		Boolean,
				default: 	true,
			},
			show_delivery: {
				type: 		Boolean,
				default: 	true,
			},
			store_status: {
				type: Object
			}
		},


		data() {
			return {
				forPennMed: 	false,
				viewTitle: 		'Login',
				currentView: 	'options', // "createAccount", "login"
				actionBtnText: 	'',

				deliveryIsOpen: 	false,
				deliveryIsEnabled: 	false,

				pickupIsOpen: 		false,
				pickupIsEnabled: 	false,

				login: {
					error: '',

					username: {
						value: '',
						isValid: false
					},

					password: {
						value: '',
						isValid: false,
					},

					submit: {
						error: '',
						isSubmitting: false,						
					}
				},

				createAccount: {
					error: '',

					firstName: {
						value: '',
						isValid: false,
					},

					lastName: {
						value: '',
						isValid: false,
					},

					email: { 
						value: '',
						isValid: '',
					},

					password: {
						value: '',
						isValid: false,
					},

					pennMedCode: {
						value: '',
						isValid: false,
					},

					submit: {
						error: '',
						isSubmitting: false,						
					}
				},
			}
		},

		computed: {
			loginSubmitIsDisabled() {
				return ( this.login.username.isInvalid || this.login.password.isInvalid )
			},

			createAccountSubmitIsDisabled() {
				return ( this.createAccount.email.isInvalid || this.createAccount.password.isInvalid )
			},			
		},

		methods: {
			resetView() {
				this.currentView 	= 'options'
				this.viewTitle 		= 'Login'
				this.forPennMed 	= false
				this.actionBtnText 	= ''
			},


			handleOptionClick( action, view, forPennMed = false ) {
				this.currentView 	= action
				this.viewTitle 		= view
				this.forPennMed 	= forPennMed
				this.actionBtnText 	= view
			},


			handleClickGuest() {
				this.$emit( 'user_clicked_guest' )
			},

			processLogin() {
				const username 	= this.login.username,
					password 	= this.login.password

				// prevent submitting twice
				if( this.login.submit.isSubmitting ) {
					return
				}

				let usernameIsValid = this.$refs.loginUsername.checkIfValid(),
					passwordIsValid = this.$refs.loginPassword.checkIfValid()

				const overallIsValid = usernameIsValid && passwordIsValid

				if( !overallIsValid ) {
					return
				}				

				this.login.submit.error = ''
				this.login.submit.isSubmitting = true

				WpApi
					.submitUserLogin( username.value, password.value )
					.then( result => {
						const { success, data } = result

						this.login.submit.isSubmitting = false

						if( !success ) {
							this.login.submit.error = data
						} else {
							this.$emit( 'user_logged_in', data )
						}
					})				
			},


			processCreateAccount() {
				const firstName = this.createAccount.firstName,
					lastName 	= this.createAccount.lastName,
					email 		= this.createAccount.email,
					password 	= this.createAccount.password,
					pennMed 	= this.createAccount.pennMedCode

				// prevent submitting twice
				if( this.createAccount.submit.isSubmitting ) {
					return
				}

				let firstNameIsValid 	= this.$refs.createAccountLastName.checkIfValid(),
					lastNameIsValid 	= this.$refs.createAccountFirstName.checkIfValid(),
					emailIsValid 		= this.$refs.createAccountEmail.checkIfValid(),
					PasswordIsValid 	= this.$refs.createAccountPassword.checkIfValid(),
					PennMedIsValid 		= this.$refs.createAccountPennMed.checkIfValid()

				const overallIsValid = firstNameIsValid && lastNameIsValid && emailIsValid && PasswordIsValid && PennMedIsValid

				if( !overallIsValid ) {
					return
				}

				this.createAccount.submit.error = ''
				this.createAccount.submit.isSubmitting = true

				WpApi
					.submitUserCreate( 
						firstName.value,
						lastName.value,
						email.value, 
						password.value, 
						pennMed.value 
					).then( result => {
						const { success, data } = result

						this.createAccount.submit.isSubmitting = false

						if( !success ) {
							this.createAccount.submit.error = data
						} else {
							this.$emit( 'user_logged_in', data )
						}
					})
			}

		},
	}
</script>